import { safeObject } from "@lib/object"

import { BaseProvider } from "./base.provider"

export class AnalyticProvider extends BaseProvider {
  sendGoogleEvent(params: GoogleEventParams) {
    const { action, category, label, value } = params

    // TODO: add interface
    // @ts-ignore
    const { ga } = window
    if (!ga) return

    ga(
      "send",
      safeObject({
        eventCategory: category,
        eventAction: action,
        hitType: "event",
        eventLabel: label,
        eventValue: value,
      }),
    )
  }
}

interface GoogleEventParams {
  action: string
  category: string
  label?: string
  value?: unknown
}
